import { postData } from "./apis";

const path = "/dashboard";

export const getProfitLossBalanceApi = (value) => {
  let endPoint = `${path}/get-profit-loss-balance`;
  return postData(endPoint, value);
};

export const getSalesAmountApi = (value) => {
  let endPoint = `${path}/get-sales-amount`;
  return postData(endPoint, value);
};

export const getSalesBalanceApi = (value) => {
  let endPoint = `${path}/get-sales-balance`;
  return postData(endPoint, value);
};

export const getIndirectExpenseBalanceApi = (value) => {
  let endPoint = `${path}/get-indirect-expense-balance`;
  return postData(endPoint, value);
};

export const purchaseSalesApi = (value) => {
  let endPoint = `${path}/purchase-sales`;
  return postData(endPoint, value);
};

export const getDeatailStockApi = (value) => {
  let endPoint = `${path}/get-detail-stock`;
  return postData(endPoint, value);
};

export const getDebitorRcvRecordApi = (value) => {
  let endPoint = `${path}/get-debitor-rcv-record`;
  return postData(endPoint, value);
};

export const bestSellingProductsApi = (value) => {
  let endPoint = `${path}/best-selling-products`;
  return postData(endPoint, value);
};
export const leastSellingProductsApi = (value) => {
  let endPoint = `${path}/least-selling-products`;
  return postData(endPoint, value);
};
export const mostProfitableCustomerApi = (value) => {
  let endPoint = `${path}/most-profitable-customers`;
  return postData(endPoint, value);
};

export const getIndireactIncomeBalanceApi = (value) => {
  let endPoint = `${path}/get-indirect-income-balance`;
  return postData(endPoint, value);
};

export const getActiveUsersCountApi = (value) => {
  let endPoint = `${path}/active-users-count`;
  return postData(endPoint, value);
};
export const getLastSevenMonthsPurchaseAndSalesApi = (value) => {
  let endPoint = `${path}/last-seven-months-purchase-sales`;
  return postData(endPoint, value);
};